// extracted by mini-css-extract-plugin
export default {"advertDetailService__label":"c-o_hu","advertDetailService__price":"c-o_hv"};